<div fxlayout="column">
  <h2 mat-dialog-title>
    {{ "inspectionImageEditErrorDialog.error" | translate }}
  </h2>
  <div fxLayoutAlign="center center" fxlayout="column">
    <div fxLayout="column" fxLayoutAlign="center" fxLayoutGap="5px">
      <mat-dialog-content fxLayoutAlign="center start">
        <mat-icon aria-label="" color="warn">error</mat-icon>
      </mat-dialog-content>
      <div>
        <p id="message" class="message">
          {{ "inspectionImageEditErrorDialog.errorMessage1" | translate: { successFileCount: successFileCount, fileCount: fileCount } }}
          <br />
          <br />{{ "inspectionImageEditErrorDialog.errorMessage2" | translate }}
        </p>
      </div>
      <div>
        <p id="file-name" class="file-name">
          <ng-container *ngFor="let failedFile of failedFileNameList"
            >{{ failedFile }}
            <br />
          </ng-container>
        </p>
      </div>
      <mat-dialog-actions fxLayoutAlign="center start">
        <button mat-raised-button [mat-dialog-close]="true" color="primary">
          {{ "inspectionImageEditErrorDialog.close" | translate }}
        </button>
      </mat-dialog-actions>
    </div>
  </div>
</div>
